export const KEY_STORAGE = {
  INTERNET_METER: "INTERNET_METER",
  TOKEN_KEY: "USER_INFO",
  CAREER_PATH: "CAREER_PATH",
  VIX_LIST_FILTER_OPTION: "VIX_LIST_FILTER_OPTION",
  UTM_SOURCE: "UTM_SOURCE",
  UTM_MEDIUM: "UTM_MEDIUM",
  UTM_CAMPAIGN: "UTM_CAMPAIGN",
  JOB_VACANCY_UTM_SOURCE: "JOB_VACANCY_UTM_SOURCE",
  EXPLORE_VIX_PAGE: "EXPLORE_VIX_PAGE",
  SELECTED_PROMO: "SELECTED_PROMO",
  IS_REDIRECT_TO_TYPEFORM: "IS_REDIRECT_TO_TYPEFORM",
  TALENT_HIRING: "TALENT_HIRING",
  EMAIL_VERIFICATION_TOKEN: "EMAIL_VERIFICATION_TOKEN",
  MATCH_MAKING: "MATCH_MAKING",
  IQ_TEST_STATE: "IQ_TEST_STATE",
  PBI: "PBI",
  DATA_ONBORDING_IQ_TEST: "DATA_ONBOARDING_IQ_TEST",
  FIRST_VISITED_HIRING_DASHBOARD: "FIRST_VISITED_HIRING_DASHBOARD",
  TPA_TEST_DURATION: "TPA_TEST_DURATION",
  IQ_TEST_DURATION: "IQ_TEST_DURATION",
  PROCTORING_STEP: "PROCTORING_STEP",
  ASSESSMENT_FEEDBACK_ID: "ASSESSMENT_FEEDBACK_ID",
  ASSESSMENT_CAMERA: "ASSESSMENT_CAMERA",
  PROCTORING_HARDWARE_STATUS: "PROCTORING_HARDWARE_STATUS",
  CAMERA_ERROR_TIMES: "CAMERA_ERROR_TIMES",
  ASSESSMENT_CURRENT_QUESTION_IDX: "CURRENT_QUESTION_IDX",
  ADDITIONAL_QUESTIONS_ANSWER: "ADDITIONAL_QUESTIONS_ANSWER",
  ASSESSMENT_TOKEN: "ASSESSMENT_TOKEN",
  PREFERRED_LANGUAGE: "PREFERRED_LANGUAGE",
  CAMERA_SYSTEM: "CAMERA_SYSTEM",
  RECRUITMENT_PRIVACY_POLICY: "RECRUITMENT_PRIVACY_POLICY",
};

/**
 * Session-scoped state that belongs to the signed-in user rather than to the browser tab.
 *
 * `sessionStorage` is per-tab, not per-authentication, and this is a SPA — logout and the next
 * login happen in the same tab, so anything left here is inherited by whoever signs in next.
 * `clearAuthStorage` removes these on sign-out and on a 401.
 *
 * Listed explicitly rather than cleared wholesale: plenty of other `sessionStorage` state is
 * genuinely tab-scoped and not the user's (proctoring hardware checks, in-flight exam progress),
 * and wiping it on logout would be its own bug.
 */
export const SESSION_KEY_STORAGE = {
  HIRING_DASHBOARD_FILTER: "hiring-dashboard-v2:filter",
};

export const URL_WHATSAPP_UMMI = "https://api.whatsapp.com/send?phone=6281213346783&text=";
export const URL_WHATSAPP_FAJAR = "https://api.whatsapp.com/send?phone=6281327823251&text=";
export const URL_WHATSAPP_DIKA = "https://api.whatsapp.com/send?phone=6281213363001&text=";
export const URL_WHATSAPP_DIANA = "https://api.whatsapp.com/send?phone=6281291066905&text=";
export const URL_WHATSAPP_WILDAN = "https://api.whatsapp.com/send?phone=6285864441855&text=";
export const URL_WHATSAPP_NURUL = "https://api.whatsapp.com/send?phone=6285692595117&text=";
export const URL_WHATSAPP_CSO = "https://api.whatsapp.com/send?phone=62881025596834&text=";
export const URL_WHATSAPP_ELNI = "https://api.whatsapp.com/send?phone=6282216220825&text=";
export const URL_WHATSAPP_AZKIA = "https://api.whatsapp.com/send?phone=6281311838835&text=";
export const URL_WHATSAPP_CUSTOMER_SUCCESS =
  "https://api.whatsapp.com/send?phone=62881025595610&text=";
export const URL_INSTAGRAM_RAKAMIN = "https://instagram.com/rakaminacademy?igshid=2gfm5ztz81pj";

export const JobGuaranteeProgramUrl =
  "https://drive.google.com/file/d/1jvNNYdWW3TeVo4bOrZpeAgPMggx9nTRt/view";
